module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_ys80@2x.262b9481.png";